import { createReducer } from "@reduxjs/toolkit";
import {
  FETCH_DAYS_OFF_SUCCESS,
  ADD_DAYS_OFF_SUCCESS,
  EDIT_DAYS_OFF_SUCCESS,
  DELETE_DAYS_OFF_SUCCESS,
} from "~/store/action_types";

const reducer = createReducer({}, (builder) => {
  builder
    .addCase(DELETE_DAYS_OFF_SUCCESS, (state, action) => {
      const { [action.daysOffId]: _deleted, ...rest } = state;
      return rest;
    })
    .addMatcher(
      (action) => [FETCH_DAYS_OFF_SUCCESS, EDIT_DAYS_OFF_SUCCESS, ADD_DAYS_OFF_SUCCESS].includes(action.type),
      (state, action) => {
        const { response = { entities: {} } } = action;
        const { entities = { days_off: {} } } = response;
        const { days_off } = entities;
        if (days_off) {
          return {
            ...state,
            ...days_off,
          };
        }
        return state;
      }
    );
});

export default reducer;
